function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Combined Shape");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "translateHover",
  transform: "translate(-863.000000, -279.000000)"
}, React.createElement("path", {
  d: "M871.846154,320.817702 C867.735774,318.258222 865,313.698598 865,308.5 C865,300.491871 871.491871,294 879.5,294 C883.305624,294 886.768826,295.466087 889.355617,297.864272 C901.549486,287.354155 917.424049,281 934.782063,281 C973.238482,281 1004.41357,312.188565 1004.41357,350.66161 C1004.41357,389.134655 973.238482,420.323221 934.782063,420.323221 C896.325645,420.323221 865.150558,389.134655 865.150558,350.66161 C865.150558,339.981892 867.552785,329.863487 871.846154,320.817702 Z",
  id: "Combined-Shape"
}));

var SvgContainerLine = function SvgContainerLine(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Hover",
    viewBox: "0 0 143 143",
    fill: "none",
    stroke: "#9ACB39",
    strokeWidth: 2.1,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgContainerLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/container_line.f83d2b48.svg";
export { ForwardRef as ReactComponent };